import { useState, useContext, createContext } from "react"



const AuthContext = createContext({
  user: null,
  login: () => { },
  logout: () => { },
})

export function useAuth() {
  return useContext(AuthContext)
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)

  const login = (data) => {
    setUser(data)
  }

  const logout = () => {
    setUser(null)
  }

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}
